/**
 * ScoreCard — ScoreRing wrapped in a Card. Use when the score should stand
 * alone as its own panel.
 */
import { Card, CardContent } from '../ui/card';
import ScoreRing, { type ScoreRingProps } from './ScoreRing';

interface ScoreCardProps extends Omit<ScoreRingProps, 'className'> {
    className?: string;
}

export default function ScoreCard({ className, ...ringProps }: ScoreCardProps) {
    return (
        <Card className={`border-subtle ${className ?? ''}`}>
            <CardContent className="p-4">
                <ScoreRing {...ringProps} />
            </CardContent>
        </Card>
    );
}
